import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Confidencialidad from '../images/confidencialidad.svg';
import Eficiencia from '../images/eficiencia.svg';
import Cliente from '../images/cliente.svg';
import Vision from '../images/vision.svg';
import '../styles/ContratacionPublica.css';
import '../styles/CustomSlider.css';

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import Slider from "react-slick";

const slides = [
    { title: "Gestiona y eficienta la operacion del área de licitaciones", color: "rgba(10, 35, 66)" },
    { title: "Administra eficientemente los riesgos legales en procedimiento s de contratación pública", color: "rgba(10, 35, 66)" },
    { title: "Evalua el cumpliento de la regulación aplicable ", color: "rgba(10, 35, 66)" },
    { title: "Revisa altos volumenes de documentos y datos con IA", color: "rgba(10, 35, 66)" },
    { title: "Elabora cartas y convenios de forma automatizada y con asistencia de IA", color: "rgba(10, 35, 66)" },
];

const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 4000,
    arrows: true,
    centerMode: true,
    centerPadding: '25%',
    focusOnSelect: true,
    responsive: [
        {
            breakpoint: 768,
            settings: {
                centerPadding: '20px',
            },
        },
    ],
};


export function ContratacionPublicaPage() {
    return (
        <Box className="box-contratacion">
            <Grid container spacin g={2}>

                <Grid size={12} className="section-contratacion">
                   { /*<div className="overlay"></div>*/}
                    <Grid size={12} className="section1-contratacion">
                        <h1>LA ESCENCIA DE LA TRANSFORMACIÓN</h1>
                        <p>Legabot para tus licitaciones </p>
                    </Grid>
                </Grid>

                <Grid size={12} className="section2-contratacion">
                        <p>Los datos son la base de la innovación, por eso es importante entender como los obtenemos y para qué los necesitamos.</p>
                        <p>Damos seguimiento y gestión de procedimientos de contratación pública</p>
                </Grid>


                <Grid size={12} className="section3-contratacion">
                       <p>BENEFICIOS</p>
                </Grid>
            
                <div style={{
                    padding: "40px 0",
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    width: '100%',
                    minHeight: '600px'
                }}>
                    <div style={{
                        width: '100%'
                    }}>
                        <Slider {...settings}>
                            {slides.map((slide, index) => (
                                <div key={index}>
                                    <div style={{
                                        height: '400px',
                                        margin: '0 10px',
                                        borderRadius: '15px',
                                        background: slide.color,
                                        boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        padding: '20px'
                                    }}>
                                        <h1 style={{
                                            color: 'white',
                                            fontSize: '60px',
                                            fontWeight: '300',
                                            textAlign: 'center',
                                            margin: 0,
                                            lineHeight: '1.3',
                                            textShadow: '0 2px 4px rgba(0,0,0,0.3)'
                                        }}>{slide.title}</h1>
                                    </div>
                                </div>
                            ))}
                        </Slider>
                    </div>
                </div>




                <Grid size={12} className="section-info-contratacion" mt={5}>
                    <div className="overlay2"></div>
                    <Grid size={12} className="section4-info-contratacion">
                        <p>Transiciona hacia lo digital con confianza.</p>
                        <button className="button-propuesta-contratacion">Solicitar demo</button>
                    </Grid>
                </Grid>

            </Grid>
        </Box>
    );
}

